import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/layouts/default.vue").then(m => m.default || m)),
  guest: defineAsyncComponent(() => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/layouts/guest.vue").then(m => m.default || m))
}